/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_DetailInputs */

const es_admin_billing_bills_list_col_detail = /** @type {(inputs: Admin_Billing_Bills_List_Col_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle`)
};

const en_admin_billing_bills_list_col_detail = /** @type {(inputs: Admin_Billing_Bills_List_Col_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail`)
};

/**
* | output |
* | --- |
* | "Detail" |
*
* @param {Admin_Billing_Bills_List_Col_DetailInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_detail = /** @type {((inputs?: Admin_Billing_Bills_List_Col_DetailInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_DetailInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_detail(inputs)
	return en_admin_billing_bills_list_col_detail(inputs)
});
export { admin_billing_bills_list_col_detail as "admin.billing.bills_list.col_detail" }